<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container>
    <div class="mic_container">
      <v-form ref="form" class="mic_form">
        <v-toolbar card color="#5ba322" dark class="mic_form-spacer">
          <v-toolbar-title>Benutzerübersicht</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-tabs color="#5ba322" dark slider-color="#f5a900">
          <v-tab key="0" ripple>Benutzer</v-tab>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            class="mic-search-left mic-search-bottom"
            single-line
            hide-details
          ></v-text-field>
          <v-tab-item key="0">
            <v-card flat>
              <v-data-table
                :headers="targetHeaders"
                :items="data"
                :search="search"
                class="elevation-1"
              >
                <v-progress-linear
                  v-if="loading"
                  v-slot:progress
                  color="blue"
                  indeterminate
                ></v-progress-linear>
                <template v-slot:items="props">
                  <td>
                    {{ props.item['lastname'] }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item['firstname'] }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item['email'] }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item['_created_at'] | formatDate }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item['trainingsId'] }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item['paid'] | germanBoolean }}
                  </td>
                  <td>
                    <div id="btn">
                      <font-awesome-icon color="green" style="cursor: pointer;" icon="euro-sign" @click="setPayment(props.item, true)"/>
                    </div>
                  </td>
                  <td>
                    <div id="btn">
                      <font-awesome-icon color="green" style="cursor: pointer;" icon="check-circle" @click="setTraining(props.item)"/>
                    </div>
                  </td>
                  <td>
                    <div id="btn">
                      <font-awesome-icon color="red" style="cursor: pointer;" icon="trash" @click.stop="                        
                        showDeleteDialog = true;
                        dataUser = props.item;"/>
                    </div>
                    <div v-if="dataUser">
                      <Delete-dialog
                        v-model="showDeleteDialog"
                        v-bind:dataUser="dataUser"
                        :deleteUser="deleteUser"
                      />
                    </div>
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-form>
    </div>
  </v-container> </template
>

<script>
import { userService } from '../_services';
import DeleteDialog from '../components/DeleteDialog.vue';

export default {
  components: { DeleteDialog },
  data() {
    return {
      data: [],
      dataUser: {},
      loading: true,
      search: '',
      showDeleteDialog: false,
      components: DeleteDialog,
      targetHeaders: [
        {
          text: 'Nachname',
          align: 'center',
          sortable: true,
          value: 'lastname'
        },
        {
          text: 'Vorname',
          align: 'left',
          sortable: false,
          value: 'firstname'
        },
        { text: 'Email', align: 'center', sortable: false, value: 'email' },
        {
          text: 'erstellt am',
          align: 'center',
          sortable: true,
          value: '_created_at'
        },
        {
          text: 'Trainings ID',
          align: 'center',
          sortable: false,
          value: 'trainingsId'
        },
        {
          text: 'Bezahlt',
          align: 'center',
          sortable: true,
          value: 'paid'
        }
      ]
    };
  },
  created() {
    userService.getAllUsersAndTrainings().then(
      response => {
        this.loading = false;
        this.data = response.data;
      },
      error => {
        this.loading = false;
        console.error(error);
      }
    );
  },
  methods: {
    setTraining(item) {
      userService.setTraining(item.id, item.trainingsId).then(response => {
        this.fetchItems();
      });
    },
    setPayment(item, status) {
      userService.setPaymentStatus(item.id, status).then(response => {
        this.fetchItems();
      });
    },
    deleteUser: function() {
      userService.deleteUser(this.dataUser.id).then(response => {
        this.fetchItems();
      });
    },
    fetchItems() {
      userService.getAllUsersAndTrainings().then(
        response => {
          this.loading = false;
          this.data = response.data;
        },
        error => {
          this.loading = false;
          console.error(error);
        }
      );
    }
  }
};
</script>

<style scoped="true">
.container {
  max-width: 100%;
}
/*.v-text-field {*/
/*margin-top: 20px!important;*/
/*}*/
.v-input--radio-group {
  margin-top: 40px !important;
}
.mic_subheader {
  margin-top: 50px;
}
.mic_double-item-input-row {
  padding-right: 25px;
}
.mic_button_spacer {
  margin-top: 25px;
}
.v-text-field__details {
  margin-top: 40px;
}

.horizontal-scroll {
  overflow: auto;
  white-space: nowrap;
}

.text-xs-center {
  text-align: center;
}

.mic-search-left {
  margin-left: 1300px;
}

.mic-search-bottom {
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/user/UserOverviewPage.vue